import { render } from "./footer.vue?vue&type=template&id=3f2ae7a1&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=3f2ae7a1&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2ae7a1"],['__file',"src/components/public/footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f2ae7a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f2ae7a1', __exports__)) {
    console.log('reload')
    api.reload('3f2ae7a1', __exports__)
  }
  
  module.hot.accept("./footer.vue?vue&type=template&id=3f2ae7a1&scoped=true", () => {
    console.log('re-render')
    api.rerender('3f2ae7a1', render)
  })

}


export default __exports__